<template>
    <div class="master-detail-layout">
        <div class="sidebar">
            <slot name="sidebar"></slot>
        </div>
        <div class="main">
            <header>
                <slot name="header"></slot>
            </header>
            <div class="content customScroll">
                <slot name="content" v-if="!loading"></slot>
                <Loader :status="loading"></Loader>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from 'components/loader/loader.vue';

export default {
    name: 'MasterDetailLayout',
    components: { Loader },
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

$headerHeight: 70px;

.master-detail-layout {
    display: flex;
    width: 100%;
    flex: 1;
}

.sidebar {
    position: relative;
    width: 25%;
}

.main {
    flex: 1;
    position: relative;
}

header {
    height: $headerHeight;
    border-top: $border;
    border-bottom: $border;
}

.content {
    flex: 1;
    width: 100%;
    height: calc(100% - #{$headerHeight});
    position: absolute;
    padding: 15px;
    overflow-y: auto;
}

</style>
